import { Link } from "react-router-dom";
import { useEffect, useState } from 'react'
import { Api } from '../api/baseApi'
import { useTranslation } from 'react-i18next';

const Blog = () => {
  const { i18n, t } = useTranslation();
  const isPrerender =
    typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent);

  let [blogs, setBlogs] = useState([])
  let [totalPages, setTotalPages] = useState(0)
  let [activePage, setActivePage] = useState(1)

  useEffect(() => {
    Api.get(`/api/${i18n.language}/blogs?type=Nomio`).then((res) => {
      console.log(res);
      setBlogs(res.data.blogs)
      setTotalPages(Math.ceil(res.data.blogs.length / 6))
    })
  }, [i18n.language])

  const getImageUrl = (frontFiles) => {
    const assetBaseUrl = (process.env.REACT_APP_PAGE_URL || "").replace(/\/$/, "");

    if (!frontFiles) return "";

    const rawFile =
      typeof frontFiles === "string"
        ? frontFiles
        : Array.isArray(frontFiles)
          ? frontFiles[0]?.file
          : frontFiles.file;

    if (!rawFile) return "";

    const buildEncodedUrl = (value) => {
      const [pathPart, queryPart] = value.split("?");
      const encodedPath = encodeURI(pathPart);
      return queryPart ? `${encodedPath}?${queryPart}` : encodedPath;
    };

    if (/^https?:\/\//i.test(rawFile)) return buildEncodedUrl(rawFile);
    if (!assetBaseUrl) return buildEncodedUrl(rawFile);

    const normalizedFile = rawFile.startsWith("/") ? rawFile.slice(1) : rawFile;
    return buildEncodedUrl(`${assetBaseUrl}/${normalizedFile}`);
  };
  const chagePosition = (num) => {
    setActivePage(num)
  }

  const getBlogPath = (slug) => (
    i18n.language === "hy" ? `/blog/${slug}` : `/${i18n.language}/blog/${slug}`
  );


  return (
    <section className="blog padding-y-120 section-bg position-relative z-index-1 overflow-hidden">

      <div className="container container-two">
        <div className="row gy-4">
          {blogs.length > 0 && blogs.slice(((activePage - 1) * 6), (activePage * 6)).map((item, index) => (
            <div key={index} className="col-lg-4 col-sm-6">
              <div className="post-item">
                <div className="post-item__thumb blogs_section">
                  <div className="link">
                    <img
                      src={getImageUrl(item.front_files)}
                      className="cover-img"
                      alt={item.typetable?.translate?.title}
                    />
                  </div>
                </div>
                <div className="post-item__content">
                  <div className="post-item__top flx-align">
                    <div
                      className="post-item__tag pill font-14 text-heading fw-500"
                    >
                      {item.typetable?.translate?.title}
                    </div>
                  </div>
                  <h5 className="post-item__title">
                    {item.translate?.title && <div className="custom-post__title" dangerouslySetInnerHTML={{ __html: item.translate?.title }} />}
                  </h5>
                  <Link
                    id="read-more-button"
                    to={getBlogPath(item.slug)}
                    className="btn btn-outline-light pill fw-600"
                  >
                    {t('blogPage.reade_more')}
                  </Link>
                </div>
              </div>
            </div>
          ))}

        </div>
        {isPrerender && blogs.length > 0 && (
          <div style={{ display: "none" }} aria-hidden="true">
            {blogs.map((item) => (
              <Link key={`prerender-${item.id || item.slug}`} to={getBlogPath(item.slug)}>
                {item.translate?.title || item.slug}
              </Link>
            ))}
          </div>
        )}
        {/* Pagination Start */}
        <div style={{ marginTop: "20px" }}>
          <ul className="pagination common-pagination">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
              <div
                key={'pagination' + num}
                className={`page-item ${activePage === num ? "active" : ""}`}
                onClick={() => chagePosition(num)}
              >
                <Link className="page-link" to="#">
                  {num}
                </Link>
              </div>
            ))}

            {totalPages > 1 && activePage < totalPages && (
              <div
                className="page-item pagination-next"
                onClick={() => chagePosition(activePage + 1)}
              >
                <Link className="page-link flx-align gap-2 flex-nowrap" to="#">
                  {t('clientSetup.wizard.next')}
                  <span className="icon line-height-1 font-20">
                    <i className="las la-arrow-right" />
                  </span>
                </Link>
              </div>
            )}
          </ul>
        </div>
        {/* Pagination End */}
      </div>
    </section>

  );
}

export default Blog;
